export default __webpack_public_path__ + "static/media/logo.bd0c0089.png";